module.exports = __webpack_public_path__ + "static/media/right-top-shade.3fecbe45.png";